import React, { Fragment, useEffect, useState } from "react"
import { connect } from "react-redux"
import { get } from "lodash"
import PropTypes from "prop-types"

import ButtonFixedVoice from "../../components/ButtonFixedVoice"
import BreadcrumbRouter from "../../components/Breadcrumb"
import SpinnerLoad from "../../components/SpinnerLoad"
import Typograph from "../../../../components/Typograph"

import styles from "./styles.css"

import { ensureArray } from "services/utils/validation"
import { CATEGORY_REQUEST, headers } from "./constants"
import { getSpecialistOccurrences } from "services/state/fixedVoice/action"
import { formatOccurrences } from "./utils"

import iconFlag from "../../../../assets/svg/fixed_voice_dash_flag.svg"
import iconArrowLeftDisabled from "../../../../assets/svg/fixed_voice_dash_arrow_left_disabled.svg"
import iconArrowLeft from "../../../../assets/svg/fixed_voice_dash_arrow_left.svg"
import iconArrowRightDisabled from "../../../../assets/svg/fixed_voice_dash_arrow_right_disabled.svg"
import iconArrowRight from "../../../../assets/svg/fixed_voice_dash_arrow_right.svg"
import BadgeFixedVoice from "../../components/Inputs/BadgeFixedVoice/index"
import SpecialistAnswerModal from "./SpecialistAnswerModal"

const MySpecialistRequests = ({
  occurrences,
  loadingOccurrences,
  getSpecialistOccurrences
}) => {
  const [currentPage, setCurrentPage] = useState(1)
  const [isModalOpen, setIsModalOpen] = useState({
    message: [],
    open: false
  })

  const recordObject = get(occurrences, "ocurrenceList", [])
  const records = ensureArray(recordObject)
  const occurrenceData = formatOccurrences(records)
  const totalPages = Math.ceil(get(occurrences, "totalRecords", 0) / 10)

  useEffect(() => {
    getSpecialistOccurrences(currentPage)
  }, [currentPage])

  const onCloseModal = () => {
    setIsModalOpen({ ...isModalOpen, open: false })
  }

  const goToPreviousPage = () => {
    setCurrentPage((prevPage) => prevPage - 1)
  }

  const goToNextPage = () => {
    setCurrentPage((prevPage) => prevPage + 1)
  }

  const showMore = (message) => {
    setIsModalOpen({ ...isModalOpen, message, open: true })
  }

  return (
    <div className={styles.container_specialist_requests}>
      <BreadcrumbRouter />

      <div className={styles.header_dash}>
        <Typograph
          htmlTag="h1"
          size="x_large"
          color="outer_space"
          weight="bold"
        >
          Minhas solicitações
        </Typograph>

        <ButtonFixedVoice
          name={"Solicitar análise de especialista"}
          linkName={"specialist-analysis"}
          icon={iconFlag}
          isOutline={true}
          className={styles.specialistButton}
        />
      </div>
      <div className={styles.table_container}>
        <table>
          <thead>
            <tr className={styles.border}>
              {headers.map((value, index) => (
                <th
                  style={{ paddingLeft: value === "Status" ? "34px" : "" }}
                  key={index}
                >
                  {value}
                </th>
              ))}
            </tr>
          </thead>

          <tbody>
            {occurrenceData.length === 0 && (
              <tr style={{ padding: 24 }}>
                <td>Ocorrências ainda não foram criadas.</td>
              </tr>
            )}

            {occurrenceData.length > 0 && (
              <Fragment>
                {occurrenceData.map((item, index) => (
                  <tr key={index}>
                    <td>{item.partnerOcurrence.id}</td>
                    <td>{CATEGORY_REQUEST[item.partnerOcurrence.category]}</td>
                    <td>
                      <BadgeFixedVoice type={item.partnerOcurrence.status} />
                    </td>
                    <td>
                      <div className={styles.response_specialist}>
                        <div className={styles.text_container}>
                          {item.partnerNoteList[0].note}
                        </div>
                        <div className={styles.read_more_text}>
                          <span
                            onClick={() => showMore(item.partnerNoteList)}
                            className={styles.read_more}
                          >
                            Ler mais
                          </span>
                        </div>
                      </div>
                    </td>
                  </tr>
                ))}
              </Fragment>
            )}
          </tbody>
        </table>
      </div>
      {loadingOccurrences ? (
        <div className={styles.load_container}>
          <SpinnerLoad />
        </div>
      ) : (
        <div className={styles.pagination}>
          <button onClick={goToPreviousPage} disabled={currentPage === 1}>
            {currentPage === 1 ? (
              <img
                className={styles.previous_arrow}
                src={iconArrowLeftDisabled}
                alt={"arrow to the left"}
              />
            ) : (
              <img
                className={styles.previous_arrow}
                src={iconArrowLeft}
                alt={"arrow to the left"}
              />
            )}
            Anterior
          </button>
          <span className={styles.page_container}>
            {" "}
            <span className={styles.box_current_number}>
              {currentPage}{" "}
            </span> de {totalPages}
          </span>
          <button onClick={goToNextPage} disabled={currentPage === totalPages}>
            Próxima
            {currentPage === totalPages ? (
              <img
                className={styles.next_arrow}
                src={iconArrowRightDisabled}
                alt={"arrow to the right"}
              />
            ) : (
              <img
                className={styles.next_arrow}
                src={iconArrowRight}
                alt={"arrow to the right"}
              />
            )}
          </button>
        </div>
      )}
      <SpecialistAnswerModal
        isOpen={isModalOpen.open}
        messages={isModalOpen.message}
        onCloseModal={() => onCloseModal()}
      />
    </div>
  )
}

MySpecialistRequests.propTypes = {
  occurrences: PropTypes.object,
  loadingOccurrences: PropTypes.bool,
  getSpecialistOccurrences: PropTypes.func
}

const mapStateToProps = ({ newOrder }) => ({
  occurrences: newOrder.response,
  loadingOccurrences: newOrder.loadingRequest
})

const mapActionsToProps = {
  getSpecialistOccurrences
}

export default connect(mapStateToProps, mapActionsToProps)(MySpecialistRequests)



// WEBPACK FOOTER //
// ./src/scenes/FixedVoice/Pages/MySpecialistRequests/index.js